import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-538e459e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loadinSpinner"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "modal-container" }
const _hoisted_4 = { class: "scrollable-content" }
const _hoisted_5 = { class: "content-wrapper d-flex" }
const _hoisted_6 = { class: "green-half d-flex flex-column p-3" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "bottom d-flex flex-column" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "m-0" }, null, -1))
const _hoisted_10 = { class: "white-half d-flex flex-column p-3 position-relative" }
const _hoisted_11 = ["src"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "mt-auto" }
const _hoisted_14 = { class: "px-2" }
const _hoisted_15 = { class: "px-2" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "green-mobile" }
const _hoisted_18 = { class: "row pt-4 no-gutter" }
const _hoisted_19 = { class: "col-10" }
const _hoisted_20 = { class: "col-2 pt-2 position-relative" }
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = { class: "white-mobile d-flex flex-column pt-4 pt-md-0" }
const _hoisted_23 = { class: "flex-1" }
const _hoisted_24 = ["src"]
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = { class: "bottom d-flex flex-column" }
const _hoisted_27 = { class: "px-2" }
const _hoisted_28 = { class: "px-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderSpinner = _resolveComponent("LoaderSpinner")!
  const _component_AsahiTypography = _resolveComponent("AsahiTypography")!
  const _component_AsahiClose = _resolveComponent("AsahiClose")!
  const _component_AsahiButton = _resolveComponent("AsahiButton")!
  const _component_DropDown = _resolveComponent("DropDown")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_LoaderSpinner)
        ]))
      : _createCommentVNode("", true),
    (_ctx.isOnHomepage)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "basic-modal-wrap",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.done && _ctx.done(...args)))
        }, [
          _createElementVNode("div", {
            class: "t-modal d-none d-md-flex",
            onClick: _withModifiers(() => { }, ["stop"])
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_AsahiTypography, {
                      type: "headline-2-bold",
                      color: "primary-white break-word",
                      class: "unset-line-height"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.pageContentStore?.title), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AsahiTypography, {
                      type: "headline-small",
                      color: "primary-white",
                      class: "w-100 break-word fw-light"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.pageContentStore)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              innerHTML: _ctx.pageContentStore?.body
                            }, null, 8, _hoisted_7))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedHelpPages, (helpPage, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "py-1",
                          key: index
                        }, [
                          _createVNode(_component_AsahiTypography, {
                            type: "headline-small",
                            color: _ctx.currentSlide == index ? 'primary-gold' : 'primary-white',
                            class: "w-100 clickable",
                            onClick: ($event: any) => (_ctx.selectSection(index))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(index + 1) + ". " + _toDisplayString(helpPage.section), 1)
                            ]),
                            _: 2
                          }, 1032, ["color", "onClick"]),
                          _hoisted_9
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    (_ctx.user.firstLogin === false)
                      ? (_openBlock(), _createBlock(_component_AsahiClose, {
                          key: 0,
                          class: "close-btn clickable",
                          onClick: _ctx.done
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_AsahiTypography, {
                      type: "body-1-bold",
                      color: "",
                      class: "unset-line-height mt-3"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.getCurrenthelpPage?.name), 1)
                      ]),
                      _: 1
                    }),
                    (_ctx.getCurrenthelpPage?.file.link)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: _ctx.getCurrenthelpPage?.file.link,
                          alt: ""
                        }, null, 8, _hoisted_11))
                      : _createCommentVNode("", true),
                    _createVNode(_component_AsahiTypography, {
                      type: "body-2-regular",
                      color: "primary-black",
                      class: "w-100 break-word"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          innerHTML: _ctx.getCurrenthelpPage?.body
                        }, null, 8, _hoisted_12)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["d-flex", {'justify-content-between': _ctx.currentSlide > 0, 'justify-content-end': _ctx.currentSlide <= 0}])
                      }, [
                        (_ctx.currentSlide > 0)
                          ? (_openBlock(), _createBlock(_component_AsahiButton, {
                              key: 0,
                              type: "primary",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToPreviousSlide()))
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('Back').toUpperCase()), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_AsahiButton, {
                          type: "secondary",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToNextSlide()))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.currentSlide >= (_ctx.sortedHelpPages.length - 1) ? _ctx.$t('Done').toUpperCase() : _ctx.$t('Next').toUpperCase()), 1)
                          ]),
                          _: 1
                        })
                      ], 2)
                    ])
                  ])
                ])
              ])
            ])
          ], 8, _hoisted_2),
          _createElementVNode("div", {
            class: "d-flex flex-column d-md-none w-100 h-100 overflow-y",
            onClick: _withModifiers(() => { }, ["stop"])
          }, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_AsahiTypography, {
                    type: _ctx.isMobile? 'headline-2-extrabold': 'headline-big',
                    color: "primary-white break-word",
                    class: "unset-line-height"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.pageContentStore?.title), 1)
                    ]),
                    _: 1
                  }, 8, ["type"])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  (_ctx.user.firstLogin === false)
                    ? (_openBlock(), _createBlock(_component_AsahiClose, {
                        key: 0,
                        class: "close-btn clickable invert",
                        onClick: _ctx.done
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_ctx.pageContentStore)
                ? (_openBlock(), _createBlock(_component_AsahiTypography, {
                    key: 0,
                    type: _ctx.isMobile? 'body-3-regular': 'headline-small',
                    color: "primary-white",
                    class: "w-100 break-word"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        innerHTML: _ctx.pageContentStore?.body
                      }, null, 8, _hoisted_21)
                    ]),
                    _: 1
                  }, 8, ["type"]))
                : _createCommentVNode("", true),
              _createVNode(_component_DropDown, {
                class: "mb-2 mb-md-0",
                options: _ctx.sortedHelpPages,
                modelValue: _ctx.currentSlide,
                "onUpdate:modelValue": _ctx.selectSection
              }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_AsahiTypography, {
                  type: _ctx.isMobile? 'headline-1-extrabold': 'headline-bold',
                  color: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.getCurrenthelpPage?.name), 1)
                  ]),
                  _: 1
                }, 8, ["type"]),
                (_ctx.getCurrenthelpPage?.file.link)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.getCurrenthelpPage?.file.link,
                      alt: "",
                      class: "max-w-100 my-2 my-md-0"
                    }, null, 8, _hoisted_24))
                  : _createCommentVNode("", true),
                _createVNode(_component_AsahiTypography, {
                  type: _ctx.isMobile? 'body-2-regular': 'headline-small',
                  color: "tertiary-dark-gray",
                  class: "w-100 break-word"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      innerHTML: _ctx.getCurrenthelpPage?.body
                    }, null, 8, _hoisted_25)
                  ]),
                  _: 1
                }, 8, ["type"])
              ]),
              _createElementVNode("div", _hoisted_26, [
                (_ctx.currentSlide > 0)
                  ? (_openBlock(), _createBlock(_component_AsahiButton, {
                      key: 0,
                      type: "primary",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToPreviousSlide())),
                      class: "w-100 my-1"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t('Back')?.toUpperCase()), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_AsahiButton, {
                  type: "secondary",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToNextSlide())),
                  class: "w-100 my-1"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.currentSlide >= (_ctx.sortedHelpPages.length - 1) ? _ctx.$t('Done')?.toUpperCase() : _ctx.$t('Next')?.toUpperCase()), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ], 8, _hoisted_16)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}